import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faInbox,
    faTruck,
    faCheckCircle,
    faFlask,
    faDatabase
} from '@fortawesome/free-solid-svg-icons';
import './SampleCard.css';

const SampleCard = ({ sample, onClick }) => {
    // Status icons mapping
    const statusIcons = {
        'Order Received': faInbox,
        'Sent Cargo': faTruck,
        'Cargo Delivered': faCheckCircle,
        'Lab Received': faFlask,
        'Data Delivered': faDatabase
    };

    // Calculate progress percentage
    const getProgressPercentage = () => {
        const stageOrder = ['Order Received', 'Sent Cargo', 'Cargo Delivered', 'Lab Received', 'Data Delivered'];
        const currentStageIndex = stageOrder.indexOf(sample.status.currentStage);
        return Math.round((currentStageIndex / (stageOrder.length - 1)) * 100);
    };

    // Handle click on card
    const handleCardClick = () => {
        if (onClick) onClick(sample);
    };

    return (
        <div className="samplemanager-card" onClick={handleCardClick}>
            <div className="samplemanager-card-header">
                <FontAwesomeIcon icon={statusIcons[sample.status.currentStage]} className="samplemanager-card-icon" />
                <span className="samplemanager-card-status">{sample.status.currentStage}</span>
                <span className="samplemanager-card-progress">{getProgressPercentage()}%</span>
            </div>
            <div className="samplemanager-card-body">
                <div className="samplemanager-card-patient">
                    <span className="samplemanager-card-name">{sample.firstName} {sample.lastName} <span className="samplemanager-card-id">{sample.patientId}</span></span>
                </div>
                <div className="samplemanager-card-details">
                    <div className="samplemanager-card-detail">
                        <span className="samplemanager-card-label">Barcode:</span>
                        <span className="samplemanager-card-value">{sample.barcode}</span>
                    </div>
                    <div className="samplemanager-card-detail">
                        <span className="samplemanager-card-label">Kit Type:</span>
                        <span className="samplemanager-card-value">{sample.kitType}</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SampleCard;
